<template>
  <div v-if="chartData">
    <GChart
      type="LineChart"
      :data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts/legacy'

export default {
  props:['categories', 'chartdata', 'height', 'yaxislog', 'yaxismin', 'labeldecimals'],
  components: {
    GChart
  },
  data: function() {
    return {
      chartData: null,
      chartOptions: {
        legend: 'bottom',
        smoothLine: true,
        height: this.height,
        colors: ['#0cbcf2', '#7041e5', '#beaeff', '#003666', '#a2b0bc'],
        lineWidth: 3,
        chart: {
          // title: 'Company Performance',
          // subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        }
      }
    }
  },
  mounted() {
    let data = [];
    let labels = ['Year'];
    let chartData = [];
    let row = [];

    this.categories.forEach((year, i) => {
      row = [year];

      this.chartdata.forEach((item, k) => {
        row.push(parseFloat(item.data[i]));
      });
      chartData[i + 1] = row;
    });

    this.chartdata.forEach((item, k) => {
      labels.push(item.name);
    });

    chartData[0] = labels;
    this.chartData = chartData;
  },
  methods: {
    numberWithCommas(x) {
          if (x) {
              return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } else {
              return x;
          }
      },
  },
  watch: {
      categories: (newVal, oldVal) => {
          // this.$nextTick(() => {
          //     this.$refs.myChart.refresh();
          // });
      },
      series: (newVal, oldVal) => {
          // this.$nextTick(() => {
          //     this.$refs.myChart.refresh();
          // });
      }
  }
};
</script>